import React, { useMemo } from 'react';

import { EmailTemplate } from '../../../../../../types/internal-api';
import { Field } from '../../../../../shared/components/Form';
import { t, useLocalization } from '../../../../../shared/components/l10n/l10n';

interface Props {
    hidePicker?: boolean;
    templates?: EmailTemplate[];
}

export function EmailTemplatePicker(props: Props) {
    const { hidePicker, templates } = props;

    const loadingText = useLocalization(textIds);

    const placeholderText = t`FORM_BOOKANDSEND_CHOOSEEMAILTEMPLATE`;
    const showEmailTemplates = !hidePicker && templates && templates.length > 0;
    const emailTemplatesOptions = useMemo(() => {
        return [
            {
                text: placeholderText,
                value: 0,
            },
            ...(templates || []).map(template => ({
                text: template.name,
                value: template.id,
            })),
        ];
    }, [templates, placeholderText]);

    if (!showEmailTemplates || loadingText) {
        return null;
    }

    return (
        <>
            <Field.Dropdown
                name="emailTemplate"
                options={emailTemplatesOptions}
                label={t`FORM_BOOKANDSEND_CHOOSEEMAILTEMPLATE_LABEL`}
                fieldClassName="w-full"
            />
        </>
    );
}

const textIds = ['FORM_BOOKANDSEND_CHOOSEEMAILTEMPLATE', 'FORM_BOOKANDSEND_CHOOSEEMAILTEMPLATE_LABEL'];
